function calcFn(sum, years, percent) {
  //alert("yes");

  let pf = Math.pow(percent / 100 + 1, years) - 1;
  let ff = pf / (percent / 100);
  let fv = sum * ff * 12;
  return fv.toFixed(2);
}

module.exports = calcFn;
